import  { GET_TEAM_MEMBER, TEAM_GET, PUBLIC_TEAMS } from  '../actions/ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';

export function fetchTeam() {
    return function (dispatch) {
        api.get('teams').then(async (response) => {
            // alert(JSON.stringify(response))
            if (response.status === "success") {
                let approvedTeams = response.payload.filter(x=>x.status !== "PENDING");
                let pendingTeams = response.payload.filter(x=>x.status === "PENDING");
                await dispatch({
                    type: TEAM_GET,
                    data: response.payload,
                    approvedTeams,
                    pendingTeams
                });
            }
        });
    }
}

export function fetchPublicTeams() {
    return function (dispatch) {
        api.get('all-teams').then(async (response) => {
            if (response.status === "success") {
                await dispatch({
                    type: PUBLIC_TEAMS,
                    data: response.payload
                });
            }
        });
    }
}

export function teamMemberAdd(router, data) {
	return function (dispatch) {

        let memberFormData = new FormData();
		if(data.member_image !== null && data.member_image !== undefined){
			memberFormData.append('member_image', data.member_image);
		}
		memberFormData.append('first_name', data.first_name);
		memberFormData.append('last_name', data.last_name);
		memberFormData.append('email', data.email);
        memberFormData.append('phone', data.phone);
        memberFormData.append('address_line1', data.address_line1);
		memberFormData.append('address_line2', data.address_line2);
		memberFormData.append('city', data.city);
		memberFormData.append('state', data.state);
		memberFormData.append('country', data.country);
		memberFormData.append('zipcode', data.zipcode);
		memberFormData.append('status', data.status);
        memberFormData.append('team_id', data.team_id);
        // console.log(memberFormData.get('first_name'))

        api.normalPost("team-members", memberFormData).then(async (response) => {
            if (response.status === "success") {
                api.get('team-members').then(async (response) => {
                    toast.success(MESSAGE.team_member_added, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    if (response.status === "success") {
                        await dispatch({
                            type: GET_TEAM_MEMBER,
                            data: response.payload
                        });
                    }
                });
            }
        })
    }
}

export function fetchTeamMember() {
    return function (dispatch) {
        api.get('team-members').then(async (response) => {
            if (response.status === "success") {
                await dispatch({
                    type: GET_TEAM_MEMBER,
                    data: response.payload
                });
            }
        });
    }
}


export function updateCoachStatus(status,id){
	return function(dispatch){
		let data = {};
        data.status = status
		api.put("teams/approval/"+id, data).then(async (response) => {
			if (response.status === "success") {
				dispatch(fetchTeam())
			}
		})
	}
}

export function updateTeam(router, data) {
    return function (dispatch) {
        let formData = new FormData();
		if(data.team_image !== null && data.team_image !== undefined){
			formData.append('team_image', data.team_image);
		}

		formData.append('team_name', data.team_name);
		formData.append('city', data.city);
		formData.append('interested_in_stem', data.interest_on_stem_learning === "Yes" ? true : false);
		formData.append('website_url', data.team_url);
        formData.append('description', data.description);
        api.normalPut('teams/'+data.id, formData).then(async (response) => {
            if (response.status === "success") {
                api.get('teams').then(async (response) => {
                    if (response.status === "success") {
                        toast.success(MESSAGE.team_edit_success, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        let approvedTeams = response.payload.filter(x=>x.status !== "PENDING");
                        let pendingTeams = response.payload.filter(x=>x.status === "PENDING");
                        await dispatch({
                            type: TEAM_GET,
                            data: response.payload,
                            approvedTeams,
                            pendingTeams
                        });
                    }
                });
            }
        });
    }
}


export function updateTeamMember(router, data) {
	return function (dispatch) {
        let formData = new FormData();
		if(data.member_image !== null && data.member_image !== undefined){
			formData.append('member_image', data.member_image);
		}
		formData.append('first_name', data.first_name);
		formData.append('last_name', data.last_name);
		formData.append('email', data.email);
        formData.append('phone', data.phone);
        formData.append('address_line1', data.address_line1);
		formData.append('address_line2', data.address_line2);
		formData.append('city', data.city);
		formData.append('state', data.state);
		formData.append('country', data.country);
		formData.append('zipcode', data.zipcode);
		formData.append('status', data.status);

        api.normalPut("team-members/"+data.id, formData).then(async (response) => {
            if (response.status === "success") {
                api.get('team-members').then(async (response) => {
                    toast.success(MESSAGE.team_member_edited, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    if (response.status === "success") {
                        await dispatch({
                            type: GET_TEAM_MEMBER,
                            data: response.payload
                        });
                    }
                });
            }
        })
    }
}